export default "__VITE_ASSET__C5X2eJWd__"